import { T, useGT } from 'gt-react';
import { GitForkIcon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useForkMessageAction } from './useForkFromMessage';

/** "Fork from here" on a saved reply; renders nothing where forking isn't offered. */
export function ForkMessageButton({ dbMessageId }: { dbMessageId: string }) {
  const t = useGT();
  const fork = useForkMessageAction();
  if (!fork) return null;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="h-7 w-7 text-stone-500 hover:text-stone-800"
          aria-label={t('Fork from here', {
            context:
              'button that branches a chat conversation into a new one at this message',
          })}
          onClick={() => fork(dbMessageId)}
        >
          <GitForkIcon className="h-4 w-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <T context="tooltip for the button that branches a chat conversation at this message">
          Fork from here
        </T>
      </TooltipContent>
    </Tooltip>
  );
}
